export enum SupportType {
  DOWNLOAD_FAILURE = "DOWNLOAD_FAILURE",
  HSHD_DETECTION = "HSHD_DETECTION"
}
